import {http} from '@/api/http.js'

//字典缓存
var dictCache = {
  dataSource: [],
  dictItem: {}, //以类型为归类的数据
  // 业务类型字典已删项的中文回显（仅用于 getDictLableValue）
  dictFallback: {
    record_type: {
      '2': '组学EI合同'
    }
  },
  // 返回数组，类似["A","B"]
  dictArray: function (type) {
    if (!type) {
      return [];
    }
    let dictArr = this.getDictArr(type);
    if (!dictArr) {
      return null;
    }
    return dictArr.map(item => item.dictLabel);
  },
  getDictArr: function (type) {
    return this.dictItem[type];
  },
  getDictItem: function (type, value) {//获取单个字典
    //console.log(type)
    if (!type || !value) {
      return null;
    }
    var dictArr = this.getDictArr(type);
    if (!dictArr) {
      return null;
    }
    var dict = dictArr.filter(d => d.dictValue == value)[0];
    return dict;
  },
  getDictLableValue: function (dictCode, value) { //获取文本
    if (value == undefined || value == null) {
      return '';
    }
    value = value.toString();
    var dict = this.getDictItem(dictCode, value);
    if (dict) {
      return dict.dictLabel;
    }
    // 字典已删除的历史值，用本地兜底文案回显
    var fallback = this.dictFallback[dictCode] && this.dictFallback[dictCode][value];
    if (fallback) {
      return fallback;
    }
    return value;//如果找不到对应的字典值,就直接返回字典值文本(可能是用户输入项)
  },
  getDictCodeByDictLable: function (dictCode, dictLable) {//根据名称匹配字典值
    var dictArr = this.getDictArr(dictCode);
    if (!dictArr) {
      return dictLable;
    }
    var target = dictArr.find(d => d.dictLabel == dictLable.toString().trim());
    if (!target) {
      return dictLable;
    }
    return target.dictValue;
  },
  getDictLableValueMultiple: function (dictCode, value) { //获取多选字典显文本，value为字符串IDS
    if (!value) {
      return '';
    }
    if (value.indexOf(',') == 0) {//如果只有一个
      return this.getDictLableValue(dictCode, value);
    }
    //多个
    let lableStr = '';
    let i = 0;
    let id_arr = value.split(',');
    id_arr.forEach(d => {
      lableStr += this.getDictLableValue(dictCode, d);
      if (i < id_arr.length - 1) {
        lableStr += '、';
      }
      i++;
    })
    return lableStr;
  },
  initalizeDict: function () { //初始化字典
    let that = this;
    http.$get('/sysDictData/list', {}
    ).then(function (res) {
      that.dataSource = res.data;
      that.dictItem = {};
      that.processDict();
      // console.log(that.dictItem)
    }).catch(function (error) {
      console.log(error);
    });
  },
  processDict: function () {
    let that = this;
    if (!that.dataSource || that.dataSource.length == 0) {
      return;
    }
    that.dataSource.forEach((d) => {
      if (d.status == 1) { //过滤禁用的
        return;
      }
      // if(d.dictValue == 'customerApply'){
      //   console.log(1);
      // }
      var dictType = d.dictType;
      if (!dictType || dictType == null) {
        return;
      }
      var d_type_arr = that.dictItem[dictType];
      if (!d_type_arr) {//如果没有，就初始一个
        d_type_arr = [];
      }
      d_type_arr.push(d);
      that.dictItem[dictType] = d_type_arr;
    })
  }
}
export default dictCache;



// WEBPACK FOOTER //
// ./src/components/dict/dictCache.js